import { createText } from '@shopify/restyle';
import React from 'react';

import { Theme } from '@themes/theme';

const RestyleText = createText<Theme>();

interface TextProps extends React.ComponentProps<typeof RestyleText> {
  disableFontScaling?: boolean;
}

const Text = React.forwardRef<React.ElementRef<typeof RestyleText>, TextProps>(
  ({ disableFontScaling = false, ...props }, ref) => {
    return (
      <RestyleText
        ref={ref}
        {...props}
        allowFontScaling={!disableFontScaling}
      />
    );
  }
);

Text.displayName = 'Text';

export default Text;
